import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { AiFillCaretRight, AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

const IndoPersonalLoan = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/personalaccounts-7.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "For meeting personal needs such as purchase of furniture/equipment, meeting social obligations, repair of houses etc.";

  
  const [openIndex, setOpenIndex] = useState(null);


  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "Eligibility",
      content: "Individuals (salaried and non-salaried). Inclusive of Memorandum of Understanding (M.O.U) loans",
    },
    {
      title: "Purpose",
      content: "For meeting of personal needs",
    },
    {
      title: "Security",
      content: [
        { type: "SALARIED", details: ["Undertaking from employer (M.O.U)", "Legal/equitable mortgage will be required where no undertaking or M.O.U is available"] },
        { type: "NON-SALARIED", details: ["Legal/Equitable mortgage"] },
      ],
    },
    {
      title: "Repayment Period",
      content: "Maximum of 36 months",
    },
    {
      title: "Note",
      content: "In case of more number of employees, MOUs can be arranged with the respective employers. Please contact your nearest branch for further details.",
    },
  ];

  return (
    <>
      <Breadcrumb Heading="Personal Loan" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
      <SavePlusAccountComponent heading="Personal Loan" subHeading="Know About" btnTxt="Apply Now" content={accountContent} img={img1} logo={true} />
      <ContainsArea />

      <section>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 justify-content-center">
              <div className="faq-style1__content">
                <ul className="accordion-box mt-5">
                  {accordionData.map((item, index) => (
                    <li className="accordion block active-block" key={index}>
                      <div
                        className="acc-btn active"
                        style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                        onClick={() => handleToggle(index)}
                      >
                        <div className="icon-outer text-white">
                          {openIndex === index ? <AiOutlineArrowRight /> :  <AiOutlineArrowUp />}
                        </div>
                        <h3 className="text-white">{item.title}</h3>
                      </div>
                      <div className="acc-content current">
                        {openIndex === index && (
                          <div className="px-5">
                            {Array.isArray(item.content) ? (
                              item.content.map((section, secIndex) => (
                                <div key={secIndex}>
                                  <h5>{section.type}</h5>
                                  {section.details.map((detail, dIndex) => (
                                    <p key={dIndex}>
                                      <AiFillCaretRight className="me-1" />
                                      {detail}
                                    </p>
                                  ))}
                                </div>
                              ))
                            ) : (
                              <p>
                                <AiFillCaretRight className="me-1" />
                                {item.content}
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <p style={{ paddingLeft: "0px", paddingBottom: "50px", color: "#9e1b1e" }}>
                  <strong>
                    <em>Terms and Conditions Apply</em>
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AllAcountsSection />
    </>
  );
};

export default IndoPersonalLoan;